import React from 'react';
import './App.css';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';

import { ThemeContextProvider } from './theme/ThemeContext';
// import theme from './theme/theme'; // Removed as it is handled by Context
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import Disclaimer from './pages/legal/Disclaimer';

import GoogleTranslateInitializer from './components/landing/GoogleTranslateInitializer';

function App() {
    return (
        <ThemeContextProvider>
            <Router>
                <div className="app-content"> {/* Added for potential global styling */}
                    <GoogleTranslateInitializer />
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/disclaimer" element={<Disclaimer />} />
                    </Routes>
                </div>
            </Router>
        </ThemeContextProvider>
    );
}

export default App;
